import Vue from "vue";
import Router from "vue-router";

import store from "%root/store";

import PrivacyPolicy from "%views/PrivacyPolicy";
import GdprPolicy from "%views/GdprPolicy";
import NotFound from "%views/NotFound";

const Home = () => import(/* webpackChunkName: "home" */ "%views/Home");
const Program = () =>
  import(/* webpackChunkName: "program" */ "%views/Program");
const Messages = () =>
  import(/* webpackChunkName: "messages" */ "%views/Messages");
const Videos = () => import(/* webpackChunkName: "videos" */ "%views/Videos");
const Video = () => import(/* webpackChunkName: "videos" */ "%views/Video");
const Admin = () => import(/* webpackChunkName: "admin" */ "%views/Admin");

const TvOffer = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/TvOffer");
const TvPricing = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/TvPricing");
const InternetOffer = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/InternetOffer");
const InternetPricing = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/InternetPricing");
const AdminOffices = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminOffices");
const AdminMessages = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/Messages");
const AdminProgram = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminProgram");
const AdminVideoTags = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminVideoTags");
const AdminVideos = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminVideos");
const AdminStatistics = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminStatistics");
const AdminEvents = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminEvents");
const AdminFooter = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminFooter");
const AdminPrivacy = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminPrivacy");
const AdminGdpr = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminGdpr");
const AdminUsers = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminUsers");
const AdminLandingPage = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminLandingPage");
const AdminDiagnostics = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminDiagnostics");
const AdminBreakdown = () =>
  import(/* webpackChunkName: "admin" */ "%admin/views/AdminBreakdown");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      props: route => ({
        step: route.query.step
      })
    },
    {
      path: "/program",
      redirect: "/program/today"
    },
    {
      path: "/program/:date",
      name: "program",
      component: Program,
      props: route => ({
        current: route.params.date
      })
    },
    {
      path: "/messages/:messageId(\\d+)?",
      name: "messages",
      component: Messages,
      props: route => ({
        messageId: parseInt(route.params.messageId) || undefined
      })
    },
    {
      path: "/videos",
      name: "videos",
      component: Videos,
      props: route => ({
        page: parseInt(route.query.page) || undefined
      })
    },
    {
      path: "/videos/:videoId(\\d+)",
      name: "video",
      component: Video,
      props: route => ({
        videoId: parseInt(route.params.videoId)
      })
    },
    {
      path: "/admin",
      alias: "/login",
      name: "admin",
      component: Admin,
      props: route => ({
        exchangeToken: route.query.token
      }),
      children: [
        {
          path: "/",
          name: "admin:home",
          component: AdminLandingPage
        },
        {
          path: "tv/offer",
          name: "admin:tv-offer",
          component: TvOffer
        },
        {
          path: "tv/pricing",
          name: "admin:tv-pricing",
          component: TvPricing
        },
        {
          path: "internet/offer",
          name: "admin:internet-offer",
          component: InternetOffer
        },
        {
          path: "internet/pricing",
          name: "admin:internet-pricing",
          component: InternetPricing
        },
        {
          path: "offices",
          name: "admin:offices",
          component: AdminOffices
        },
        {
          path: "messages",
          name: "admin:messages",
          component: AdminMessages
        },
        {
          path: "program",
          name: "admin:program",
          component: AdminProgram
        },
        {
          path: "tags",
          name: "admin:videotags",
          component: AdminVideoTags
        },
        {
          path: "videos",
          name: "admin:videos",
          component: AdminVideos
        },
        {
          path: "statistics",
          name: "admin:statistics",
          component: AdminStatistics
        },
        {
          path: "events",
          name: "admin:events",
          component: AdminEvents
        },
        {
          path: "footer",
          name: "admin:footer",
          component: AdminFooter
        },
        {
          path: "privacy",
          name: "admin:privacy",
          component: AdminPrivacy
        },
        {
          path: "gdpr",
          name: "admin:gdpr",
          component: AdminGdpr
        },
        {
          path: "users",
          name: "admin:users",
          component: AdminUsers
        },
        {
          path: "diagnostics",
          name: "admin:diagnostics",
          component: AdminDiagnostics
        },
        {
          path: "breakdown",
          name: "admin:breakdown",
          component: AdminBreakdown
        }
      ]
    },
    {
      path: "/privacy",
      name: "privacy-policy",
      component: PrivacyPolicy
    },
    {
      path: "/gdpr",
      name: "gdpr-policy",
      component: GdprPolicy
    },
    {
      path: "*",
      name: "not-found",
      component: NotFound
    }
  ]
});

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored;
  next();
};

router.beforeEach(waitForStorageToBeReady);

export default router;
